'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../external/classnames/index.js');
require('prop-types');
require('../../sections/Alert/Alert.js');
require('../../sections/Article/Article.js');
require('../../sections/ArticleInfoBlock/ArticleInfoBlock.js');
require('../../sections/Banner/Banner.js');
require('../../sections/BreadCrumbs/BreadCrumbs.js');
require('../../sections/ErrorPage/ErrorPage.js');
require('../../sections/FeatureCarousel/FeatureCarousel.js');
require('../../sections/FeatureCarousel/FeaturedCarouselItem/FeaturedCarouselItem.js');
require('../../sections/FeaturedMarquee/FeaturedMarquee.js');
require('../../sections/NewsletterSubscription/NewsletterSubscription.js');
require('../../sections/OpenPositions/OpenPositions.js');
require('../../sections/OurTeam/OurTeam.js');
require('../../sections/PageHeader/PageHeader.js');
require('../../sections/Pagination/Pagination.js');
require('../../sections/PaginationContainer/PaginationContainer.js');
require('../../sections/PanelGroup/PanelGroup.js');
require('../../sections/PanelGroup/Panel/Panel.js');
require('../../sections/PodcastCarousel/PodcastCarousel.js');
require('../../sections/SecondaryNav/SecondaryNav.js');
var Section = require('../../sections/Section/Section.js');
require('../../sections/Section/SectionHeader/SectionHeader.js');
require('../../sections/SplitBanner/SplitBanner.js');
require('../../sections/SplitBanner/SplitBannerImage/SplitBannerImage.js');
require('../../sections/SplitBanner/SplitBannerVideo/SplitBannerVideo.js');
require('../../sections/SplitBanner/SplitBannerContent/SplitBannerContent.js');
require('../../sections/SplitBanner/SplitBannerContact/SplitBannerContact.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

/**
 *
 * @param {Object} props - The props object for the component.
 * @param {string} [props.id] - The id of the content body.
 * @param {React.ReactNode | string} props.body - The content of the content body.
 * @param {string} [props.className] - Additional CSS classes to apply to the content body.
 * @param {boolean} [props.isHTML] - Whether the content body is HTML or React.
 * @param {boolean} [props.isLinkable] - Whether the content body is linkable.
 * @param {boolean} [props.leftSidebar] - Whether the content body has a left sidebar.
 * @throws Will throw an error if isLinkable is true and id is undefined, null, or an empty string.
 *
 * @example
 * // Defaults isHTML=false, isLinkable=false, leftSidebar=true
 * <ContentBody isLinkable id='content-body' body='Some text' />
 *
 * @returns {JSX.Element} The rendered content body component.
 */

var ContentBody = function ContentBody(_ref) {
  var id = _ref.id,
    body = _ref.body,
    className = _ref.className,
    _ref$isHTML = _ref.isHTML,
    isHTML = _ref$isHTML === void 0 ? false : _ref$isHTML,
    _ref$isLinkable = _ref.isLinkable,
    isLinkable = _ref$isLinkable === void 0 ? false : _ref$isLinkable,
    _ref$leftSidebar = _ref.leftSidebar,
    leftSidebar = _ref$leftSidebar === void 0 ? true : _ref$leftSidebar;
  var classes = index.default('lanl-content-body', !leftSidebar && 'no-left-sidebar', className);
  if (isLinkable && (!id || id === '')) {
    throw new Error('ContentBody: isLinkable is true, but id is undefined, null, or an empty string');
  }
  return isHTML && typeof body === 'string' ? /*#__PURE__*/React__default.default.createElement(Section.Section, {
    id: id,
    isLinkable: isLinkable,
    noStyling: true
  }, /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    dangerouslySetInnerHTML: {
      __html: body
    }
  })) : /*#__PURE__*/React__default.default.createElement(Section.Section, {
    id: id,
    isLinkable: isLinkable,
    noStyling: true
  }, /*#__PURE__*/React__default.default.createElement("div", {
    className: classes
  }, body));
};

exports.ContentBody = ContentBody;
exports.default = ContentBody;
//# sourceMappingURL=ContentBody.js.map
